<script>

const axios = require('axios').default;

export default {
  name: 'ProvidersIndex',
  mixins: [axios],
  props: {
    categories: {
      required: false,
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      providersData: {},
      show: null,
    };
  },
  created() {
  },
  methods: {
    getProviders() {
      axios.get('/providers').then((response) => {
        this.providersData = response.data.providerCategories
      })
    },
    toggleView(categoryId) {
      this.show = categoryId;
    },
  },
};

</script>

<template>
  <div class="w-full bg-white text-lg rounded-lg">
    <div class="grid grid-cols-3 gap-4">
      <slot name="list" :toggleView="toggleView" :show="show"></slot>
    </div>
  </div>
</template>